// services/customerSessionService.js

import API_BASE from "../config/api";

export const createCustomerSession = async (customer_id) => {

  const token = localStorage.getItem("admin_token");

  const response = await fetch(`${API_BASE}/Customer/CreateSession`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Token": token,
    },
    body: JSON.stringify({ customer_id }),
  });

  const data = await response.json();

  if (!response.ok || data.status !== 0) {
    throw new Error(data?.message || "Session creation failed");
  }

  return data;
};